import BgImage from 'assets/images/campaign_signup_bg.png';

import { FC } from 'react';
// MUI
import { Avatar, Box, Button, Container, Typography } from '@mui/material';

import { ICampaignSettings } from 'app/hooks/useADCampaignSignup';

const items = [
  'Upload Documents',
  'Receive Email Notification for Report',
  'Review & Validate',
  'Make a Final Decision'
];

type Props = {
  pageData?: ICampaignSettings['pageData'];
  onOpen: () => void;
}

const MainPage:FC<Props> = ({ pageData, onOpen }) => {
  return (
    <Box sx={{
      flexGrow: 1,
      position: 'relative',
      bgcolor: '#fff',
    }}>
      <Box sx={{
        position: 'absolute',
        top: 0,
        right: 0,
        display: { xs: 'none', md: 'block' },
        width: { md: '35%', lg: '37%', xl: '40%' },
        height: '100%',
      }}>
        <img src={BgImage} alt="" width="100%" height="100%" />
      </Box>

      <Container maxWidth="lg" sx={{
        height: '100%',
        p: 0,
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        gap: { xs: 0, md: 10, lg: 20 },
        position: 'relative',
        zIndex: 1,
      }}>
        <Box sx={{ p: { xs: 6, sm: 8 }, flexBasis: '66.6%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <Typography sx={{
            fontSize: { xs: 24, sm: 34, md: 40, lg: 48 },
            fontWeight: 700,
            lineHeight: '120%',
            letterSpacing: '-0.5px',
            color: 'rgb(33, 33, 38)',
            '& span': {
              color: theme => theme.palette.primary.main
            }
          }}>
            {pageData?.header1 || 'Case Chronology’s Plaintiff'}
            <span>{pageData?.header2 || 'AI Auto Test Drive Promotion'}</span>
          </Typography>
          <Typography sx={{
            mt: 3,
            fontSize: { xs: 16, sm: 18, md: 20 },
            fontWeight: 700,
            lineHeight: '160%',
            letterSpacing: '-0.15px',
            color: 'rgb(33, 33, 38)',
          }}>The fastest way to implement Al into your practice</Typography>
          <Typography sx={{
            mt: 3,
            fontSize: { xs: 14, sm: 16 },
            fontWeight: 500,
            lineHeight: '150%',
            letterSpacing: '-0.15px',
            color: 'rgb(70, 70, 80)',
          }}>Case Chronology is so confident that we have the best AI Legal Tech solution for cases in litigation, we want to give you a no obligation Test Drive.</Typography>

          <Typography sx={{
            mt: 10,
            fontSize: 16,
            fontWeight: 700,
            lineHeight: '24px',
            letterSpacing: '-0.15px',
            color: 'rgb(70, 70, 80)',
          }}>How it works</Typography>
          <Box sx={{
            mt: 3, p: { xs: 2, md: 3 },
            bgcolor: 'rgb(242, 242, 247)',
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            borderRadius: 1,
          }}>
            <Avatar sx={{
              bgcolor: 'rgba(100, 100, 230, 0.12)', color: 'rgb(100, 100, 230)',
              width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 }
              }}>1</Avatar>
            <Box>
              <Typography sx={{
                fontSize: { xs: 12, sm: 16 },
                fontWeight: 600,
                lineHeight: '150%',
                color: 'rgb(70, 70, 80)',
              }}>Fill out our quick registration form</Typography>
              <Typography sx={{
                fontSize: {xs: 10, sm: 12 },
                fontWeight: 500,
                lineHeight: '143%',
                color: 'rgb(70, 70, 80)',
                letterSpacing: '0.17px',
              }}>{pageData?.step1Description || 'Must be a Plaintiff Attorney with an Auto Accident Case that is 1000 pages or less'}</Typography>
            </Box>
          </Box>
          <Box sx={{
            mt: 2, p: { xs: 2, md: 3 },
            bgcolor: 'rgb(242, 242, 247)',
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            borderRadius: 1,
          }}>
            <Avatar sx={{
              bgcolor: 'rgba(100, 100, 230, 0.12)', color: 'rgb(100, 100, 230)',
              width: { xs: 32, sm: 40 }, height: { xs: 32, sm: 40 }
            }}>2</Avatar>
            <Typography sx={{
              fontSize: { xs: 12, sm: 16 },
              fontWeight: 600,
              lineHeight: '150%',
              color: 'rgb(70, 70, 80)',
            }}>Upload your files to your secure portal that will be created upon submission</Typography>
          </Box>
          <Typography sx={{
            mt: 3,
            fontSize: { xs: 12, sm: 14 },
            fontWeight: 400,
            lineHeight: '143%',
            color: 'rgb(70, 70, 80)',
            letterSpacing: '0.17px',
          }}>{pageData?.completionNote || 'That is it! Now just wait for your AI Report designed for auto cases to be emailed to you.'}</Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              mt: { xs: 8, lg: 12 },
              maxWidth: 320,
            }}
            onClick={onOpen}
          >
            Get started
          </Button>
        </Box>
        <Box sx={{
          p: { xs: 6, sm: 8 }, flexBasis: '33.4%',
          display: 'flex', flexDirection: 'column', justifyContent: 'center',
          backgroundImage: { xs: `url(${BgImage})`, md: 'none' },
        }}>
          <Typography sx={{
            fontSize: { xs: 20, sm: 24 },
            fontWeight: 700,
            color: '#fff',
            '& span': {
              opacity: 0.8
            }
          }}><span>Get</span> AI report</Typography>
          <Box sx={{
            mt: { xs: 6, md: 8 },
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}>
            {items.map((item, index) => {
              const oddItem = index % 2 !== 0;
              const lastItem = index === items.length - 1;
              const Arrow = (
                <img
                  src={`/icons/ai-report/arrow.svg`} alt="arrow" width="24"
                  style={{
                    transform: `scaleX(${oddItem ? -1 : 1})`,
                    opacity: lastItem ? 0 : 1
                  }}
                />
              )
              return (
                <Box key={item} sx={{
                  display: 'flex',
                  alignItems: 'flex-end',
                  gap: 3,
                }}>
                  {oddItem ? Arrow : null}
                  <Box sx={{
                    flexGrow: 1,
                    padding: { xs: '28px 16px', sm: '20px 12px', lg: '36px 24px' },
                    bgcolor: '#fff',
                    display: 'flex',
                    flexDirection: { xs: 'column', sm: 'row' },
                    alignItems: 'center',
                    gap: 3,
                  }}>
                    <img src={`/icons/ai-report/${index+1}.svg`} alt={item} width="56" height="56" />
                    <Typography sx={{
                      fontSize: { xs: 16, sm: 18 },
                      fontWeight: 700,
                      lineHeight: '24px',
                      letterSpacing: '0.15px',
                      textAlign: { xs: 'center', sm: 'left' },
                    }}>{item}</Typography>
                  </Box>
                  {!oddItem ? Arrow : null}
                </Box>
              )
            })}
          </Box>
        </Box>
      </Container>
    </Box>
  )
}

export default MainPage;
